<template>
    <div>
        <Cabecalho />
        <Corpo />
        <Rodape />
    </div>
</template>

<script>
import Corpo from "../layouts/Corpo";
import Rodape from "../layouts/Rodape";
import Cabecalho from "../layouts/Cabecalho";

export default {
    name: "Dash",
    components: {
        Cabecalho,
        Corpo,
        Rodape
    }
}

</script>

<style scoped>

</style>


